import React, { useMemo, useState } from "react";
import DarkTable from "components/Table/DarkTable";
import { useData } from "hooks/useData";
import { packetsMock } from "mocks/packetsMock";
import TableActionButton from "components/Button/TableActionButton";

import { useGetPacketsQuery } from "store/apiSlice";
import { Icon, Save } from "@rsuite/icons";
import { handleDownload } from "utils";

type RawPacketsGroupTableProps = {
    callId: number | null;
    rawPacketData: Record<string, any> | null;
    rawPacketsLoading: boolean;
};


const RawPacketsGroupTable: React.FC<RawPacketsGroupTableProps> = ({ callId, rawPacketData, rawPacketsLoading }) => {
    const { data: packets, isLoading, isFetching, error, refetch } = useData(
        useGetPacketsQuery,
        packetsMock,
        { 
            call_id: callId!
        },
        !callId
    );

    const columns = [
        { 
            label: "Date/time",
            dataKey: "time",
            minWidth: 220,
            flexGrow: 1,
            align: "left",
            resizable: false
        },
        { label: "Calling Number", dataKey: "number_from", flexGrow: 1, align: "left", resizable: false },
        { label: "Called Number", dataKey: "number_to", flexGrow: 1, align: "left", resizable: false },
        {
            label: "Incoming IP",
            dataKey: "ip_src",
            value: ({ ip_src, port_src }: any) => {
                return `${ip_src}:${port_src}`;
            },
            minWidth: 180,
            flexGrow: 1,
            align: "left",
            resizable: false
        },
        {
            label: "Outgoing IP",
            dataKey: "ip_dst",
            value: ({ ip_dst, port_dst }: any) => {
                return `${ip_dst}:${port_dst}`;
            },
            minWidth: 180,
            flexGrow: 1,
            align: "left",
            resizable: false
        },
        {
            label: "Method/Code",
            dataKey: "method_code",
            // minWidth: 300,
            flexGrow: 2,
            align: "left",
            resizable: false
        }
    ];

    const packetsLoading = isLoading || isFetching;
    const loading = packetsLoading || rawPacketsLoading;

    const shouldClearPackets = !callId || loading;
    const data = shouldClearPackets ? [] : packets;

    return <>
        <DarkTable
            data={data}
            columns={columns}
            title="Raw Packets Group"
            loading={packetsLoading}
            error={error}
            showSkeleton
            // showError
            rowHeight={40}
            headerHeight={40}
            height={380}
            skeletonRows={8}
            // autoHeight
            bordered
            cellBordered
        />
    </>;
};

export default RawPacketsGroupTable;